/* eslint-disable default-case, react/sort-comp */

import {Component} from 'react';
import {connect} from 'react-redux';
import jQuery from 'jquery';

import {changeLocation, switchLocation} from '../../actionCreators';

import LocationSearch from './LocationSearch';

const DefaultState = {
    query: '',
    focus: false,
    suggestions: null,
    error: null,
};

class Wrapper extends Component {

    constructor(props) {
        super(props);

        this.ref = this.ref.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleNoPermission = this.handleNoPermission.bind(this);
        this.handleErrorConfirm = this.handleErrorConfirm.bind(this);

        this.timer = 0;
        this.request = null;
        this.node = null;

        this.state = this.constructor.getDerivedStateFromProps(props);
    }

    render() {
        return (
            <LocationSearch
                {...this.state}
                ref={this.ref}
                onKeyUp={this.handleKeyUp}
                onClick={this.handleClick}
                onFocus={this.handleFocus}
                onChange={this.handleChange}
                onSelect={this.handleSelect}
                onErrorConfirm={this.handleErrorConfirm}
            />
        );
    }

    ref(node) {
        this.node = node;
    }

    handleClick() {
        this.setSuggestions(null, false);
        if (this.node) this.node.blur();
    }

    handleChange(event) {
        const {target} = event;
        const {value} = target;

        this.fetchSuggestions(value);
        this.setState({query: value});
    }

    handleFocus() {
        const {query} = this.state;

        if (query) this.fetchSuggestions(query);

        this.setState({focus: true});
    }

    handleKeyUp(event) {
        const {focus, suggestions} = this.state;

        if (event.key === 'Escape') return this.handleClick(event);

        if (suggestions === null || suggestions.length === 0) return;

        switch (event.key) {
            case 'ArrowDown':
                return this.moveFocus(event, +1);

            case 'ArrowUp':
                return this.moveFocus(event, -1);

            case 'Enter': {
                if (focus === true || focus === false) return;

                const suggestion = suggestions[focus];

                return this.handleSelect(suggestion);
            }
        }
    }

    handleSelect({id, isCurrent}) {
        const {locationID, changeLocation, switchLocation} = this.props;

        if (id === locationID) return this.setState(DefaultState);

        if (isCurrent) {
            changeLocation(id);
        } else {
            switchLocation(id, this.handleNoPermission);
        }
    }

    handleNoPermission(html) {
        this.setError(html);
    }

    handleErrorConfirm() {
        this.setError(null);
    }

    moveFocus(event, direction) {
        event.preventDefault();

        this.setState(state => {
            const {suggestions} = state;
            const count = suggestions.length;
            let {focus} = state;

            if (focus === true) {
                focus = -(count * direction);
            } else {
                focus += direction;
            }

            if (focus < 0) focus += count;
            else if (focus >= count) focus -= count;

            return {focus};
        });
    }

    fetchSuggestions(term) {
        if (this.request) this.request.abort();
        if (this.timer) clearTimeout(this.timer);

        const completed = () => {
            this.timer = 0;
            this.request = null;
        };

        if (term.length < 3) {
            completed();
            return this.setSuggestions(null);
        }

        const {url, region} = this.props;

        this.timer = setTimeout(() => {
            this.request = jQuery.ajax(url, {
                data: {
                    region,
                    term,
                },
                dataType: 'json',
                success: ({success, locations}) => {
                    if (success) this.setSuggestions(locations);
                },
                completed,
            });
        }, 250);
    }

    setError(error) {
        return this.setSuggestions(null, false, error);
    }

    setSuggestions(suggestions, focus = true, error = null) {
        return this.setState({suggestions, focus, error});
    }

}

Wrapper.getDerivedStateFromProps = ({locationID}, state) => {
    if (state && state.locationID === locationID) return null;

    return {
        ...DefaultState,
        locationID,
    };
};

const mapStateToProps = ({suggestionsFetchURL, regionID, locationID}) => ({
    url: suggestionsFetchURL,
    region: regionID,
    locationID,
});

const mapDispatchToProps = dispatch => ({
    changeLocation: location => dispatch(changeLocation(location)),
    switchLocation: (...args) => dispatch(switchLocation(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper);
